// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
import { Component, OnInit } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { MenuComponent } from './components/menu/menu.component';
import { NavigationEnd, NavigationStart, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { filter, map, tap } from 'rxjs/operators';
import { AnnouncementComponent } from './components/announcement/announcement.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SeoService } from './shared/services/seo.service';
import { SocialShareComponent } from './components/social-share/social-share.component';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [MenuComponent, FooterComponent, RouterModule, BreadcrumbComponent, SocialShareComponent],
  providers: [DialogService]
})
export class AppComponent implements OnInit {
  public primeNgModalRef!: DynamicDialogRef;

  constructor(
    private dialogService: DialogService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService
  ) {
    this.handleRouteWithHash();
  }

  ngOnInit() {
    // push GTM data layer for every visited page
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        map(route => route.snapshot.data)
      )
      .subscribe(data => {
        if (data && data['seo']) {
          this.seoService.updateMetaTags(data['seo']);
        }
      });
  }

  private handleRouteWithHash() {
    this.router.events
      .pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart),
        filter(event => !!event.url && !!event.url.match(/^\/#/)),
        tap(event => this.router.navigateByUrl(event.url.replace('/#', '')))
      )
      .subscribe();
  }

  openAnnouncementModal() {
    const modalOptions: DynamicDialogConfig = {
      showHeader: false,
      closeOnEscape: true
    };

    this.primeNgModalRef = this.dialogService.open(AnnouncementComponent, modalOptions);
  }
}
